import styled, {
  breakpoints,
  css,
  Device,
  FloatingMessage,
  IFalconTheme,
  ResponsiveTypography,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';

const MINIMUM_PAGE_HEIGHT: number = 600;
const MINIMUM_CONFIRMATION_BOX_WIDTH: number = 500;

export const ReturnButtonContainer: StyledComponent<'div', {}, {}> = styled('div')`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
`;

export const DisclaimerText: StyledComponent<typeof ResponsiveTypography, {}, {}> = styled(
  ResponsiveTypography
)(
  () => css`
    padding: ${Scale.m} 0 ${Scale.xl};
  `
);

export const StyledFloatingMessage: StyledComponent<typeof FloatingMessage, {}, {}> = styled(
  FloatingMessage
)(
  () => css`
    width: 100%;
  `
);

export const ConfirmationDisclaimerText: StyledComponent<
  typeof ResponsiveTypography,
  {},
  {}
> = styled(ResponsiveTypography)(
  () => css`
    max-width: ${MINIMUM_CONFIRMATION_BOX_WIDTH}px;
    padding: ${Scale.xs} 0 ${Scale.m};
  `
);

export const CancellationPageContainer: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    padding-bottom: ${Scale.xl};
    @media (min-width: ${breakpoints[Device.tablet]}) {
      max-width: 100%;
      box-sizing: border-box;
    }
  `;
});

interface ICancellationPageOuterContainerProps {
  addMobilePadding: boolean;
}

export const CancellationPageOuterContainer: StyledComponent<
  'div',
  IFalconTheme,
  ICancellationPageOuterContainerProps
> = styled('div')(
  ({
    theme,
    addMobilePadding,
  }: { theme: IFalconTheme } & ICancellationPageOuterContainerProps) => css`
    background: ${theme.color.white};
    ${addMobilePadding ? `padding: ${Scale.xl} ${Scale.m} ${Scale.m};` : ''}
    @media (min-width: ${breakpoints[Device.tablet]}) {
      padding: ${Scale.xl};
      min-height: ${MINIMUM_PAGE_HEIGHT}px;
    }
  `
);

export const ConfirmationContainer: StyledComponent<'div', IFalconTheme, {}> = styled('div')(
  ({ theme }) => css`
    background: ${theme.color.grey50};
    padding: ${Scale.xl} ${Scale.m};
  `
);

export const WrapperDiv: StyledComponent<'div', {}, {}> = styled.div`
  align-items: start;
  display: flex;
  height: 100%;
  justify-content: flex-end;
  @media (min-width: ${breakpoints[Device.tablet]}) {
    width: fit-content;
    padding: ${Scale.s} ${Scale.l};
  }
  @media (max-width: ${breakpoints[Device.tablet]}) {
    width: 100%;
  }
`;
